<template>
  <div class="daterangefield">
    {{ data | date(config.decoratorOptions.format.toUpperCase()) }}&nbsp;-
    {{ endDate | date(config.decoratorOptions.format.toUpperCase()) }}
  </div>
</template>

<script>
export default {
  name: 'tablefield-date-range',
  props: ['data', 'config', 'product'],
  computed: {
    endDate() {
      return this._.get(this.product, this.config.decoratorOptions.endDatePath)
    }
  }
}
</script>



// WEBPACK FOOTER //
// FieldDateRange.vue?76505929